module.exports = __webpack_public_path__ + "static/media/dianqiyinhuan.0bd306f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/dianqiyinhuan.mp3
// module id = LqGJ
// module chunks = 208